import { Button, Flex } from '@spotify-internal/encore-web';
import { useFormFieldsContext } from '@spotify/confidence-core-react';

import { type SurveyFormValues, isRoleAnswered } from './surveyForm';

import styles from './OnboardingSurvey.module.css';

type SurveyActionsProps = {
  isSaving: boolean;
  onSkip: () => void;
};

export const SurveyActions = ({ isSaving, onSkip }: SurveyActionsProps) => {
  const { values } = useFormFieldsContext<SurveyFormValues>();
  const canSubmit = isRoleAnswered(values);

  return (
    <Flex gap="looser-3" alignItems="center" className={styles.actions}>
      <Button
        type="submit"
        variant="primary"
        colorSet="inverted"
        size="medium"
        isLoading={isSaving}
        loadingAriaLabel="Saving"
        disabled={!canSubmit || isSaving}
       data-track-source-anchor="0921ad44f0;;high">
        Submit
      </Button>
      <Button
        type="button"
        variant="tertiary"
        size="medium"
        disabled={isSaving}
        onClick={onSkip}
       data-track-source-anchor="decd337cd6">
        Skip
      </Button>
    </Flex>
  );
};
